export const YES = 'Yes';
export const NO = 'No';
export const NOT_SURE = 'Not sure';
export const UNKNOWNN = 'Unknown';
export const ZERO_DOLLAR = '$0';
export const RACQ_BANK = 'RACQ Bank';
export const DROPDOWN_PLACEHOLDER = 'Please select';
export const AUSTRALIA = 'Australia';
export const AUSTRALIA_ISO = 'AUS';
export const RACQ = 'RACQ';
export const QLD = 'QLD';
export const NONE = 'None';
export const INCLUDED = 'Included';
export const MANUAL_ADDRESS_PLACEHOLDER = 'Not on list - I will enter manually';
export const INTERNATIONAL = 'International';
export const AGREED_VALUE = 'Agreed Value';
export const MARKET_VALUE = 'Market Value';
export const ON = 'On';
export const OFF = 'Off';
export const PHONE_AUS_COUNTRY_CODE = '61';
export const CREDIT_CARD = 'Credit Card';
export const BANK_ACCOUNT = 'Bank Account';
export const CREDIT_OR_DEBIT_CARD = 'Credit or debit card';
export const OK = 'Ok';
